import { api } from "../base";

const adjustmentEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    /** Fetches active manual adjustments for an account + feed type. */
    getManualAdjustments: build.query<
      unknown[],
      { accountId: string; feedType: string }
    >({
      query: ({ accountId, feedType }) => ({
        url: "/api/adjustments/v1/active",
        params: { account_id: accountId, feed_type: feedType },
      }),
      providesTags: (_result, _error, { accountId, feedType }) => [
        { type: "ManualAdjustments", id: `${accountId}:${feedType}` },
      ],
    }),

    /** Uploads manual adjustments. */
    uploadAdjustments: build.mutation<void, unknown[]>({
      query: (payload) => ({
        url: "/api/adjustments/v1/upload",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["ManualAdjustments"],
    }),

    /** Deactivates a manual adjustment. */
    deactivateAdjustment: build.mutation<
      void,
      { accountId: string; adjustmentId: string }
    >({
      query: ({ accountId, adjustmentId }) => ({
        url: "/api/adjustments/v1/deactivate",
        params: { account_id: accountId, adjustment_id: adjustmentId },
        method: "DELETE",
      }),
      invalidatesTags: ["ManualAdjustments"],
    }),
  }),
});

export const {
  useGetManualAdjustmentsQuery,
  useLazyGetManualAdjustmentsQuery,
  useUploadAdjustmentsMutation,
  useDeactivateAdjustmentMutation,
} = adjustmentEndpoints;
